const question2 = {
    'question': 'Jak przygotować się do pierwszego spotkania z psychologiem?',
    'answer': 'Warto zastanowić się, jakie są Twoje problemy i trudności. Wybierz psychologa, który jest dla Ciebie odpowiedni. Przyjdź na spotkanie punktualnie i przygotowany. Bądź szczery i otwarty podczas rozmowy z psychologiem. Podczas porady psychologicznej możesz czuć się nieswojo lub zdenerwowany. To normalne. Pamiętaj, że psycholog jest po to, aby Ci pomóc.'
}

export default question2;